module.exports = __webpack_public_path__ + "img/main_gaul_map.cb596941.png";